module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("Новости")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('div', {
    staticClass: "news"
  }, _vm._l((_vm.allNews), function(news, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": news.url
      }
    }, [_c('p', [_vm._v(_vm._s(news.preview))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(news.date))])])
  }))]), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('aside-image', {
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16c773c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/News.vue
// module id = 122
// module chunks = 0